import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ image, icon, title, description, id }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="service-card h-100 d-flex flex-column">
        <div className="card-image">
          <img 
            src={image} 
            alt={title} 
            className="img-fluid w-100 rounded-top" 
            loading="lazy"
          />
          <div className="service-icon">
            <i className={icon}></i>
          </div>
        </div>
        <div className="card-body d-flex flex-column px-4 py-4">
          <h4 className="card-title fw-bold mb-3 text-start">{title}</h4>
          <p className="card-text mb-4 text-muted text-start">{description}</p>
          <div className="mt-auto text-start">
            <Link to={`/our-services/${id}`} className="btn-service btn-highlight">
              Learn More <i className="fas fa-arrow-right ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;